// removed by extract-text-webpack-plugin
module.exports = {"shipping":"shipping__2g5vC","price":"price__1hPki"};


//////////////////
// WEBPACK FOOTER
// ./components/blocks/shippingPage/style/ShippingTable.scss
// module id = UiFJ
// module chunks = 1